import { render, staticRenderFns } from "./BaseBinanceIcon.vue?vue&type=template&id=3d269651&scoped=true"
import script from "./BaseBinanceIcon.vue?vue&type=script&lang=js"
export * from "./BaseBinanceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d269651",
  null
  
)

export default component.exports